export default __webpack_public_path__ + "static/media/GT-Cinetype-Bold.1315bb99.woff";